import { render, staticRenderFns } from "./DeliveriesPerMonthPerFranchise.vue?vue&type=template&id=293628ea&"
import script from "./DeliveriesPerMonthPerFranchise.vue?vue&type=script&lang=js&"
export * from "./DeliveriesPerMonthPerFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports